import { useEffect, useState } from 'react';
import { DeviceOrientation } from '../constants';
import { constants as coreConstants } from '../../core';
export function useDeviceOrientation() {
    const initialDeviceOrientation = window.innerHeight > window.innerWidth
        ? DeviceOrientation.Portrait
        : DeviceOrientation.Landscape;
    const [deviceOrientation, setOrientation] = useState(initialDeviceOrientation);
    const changeOrientationHandler = (event) => {
        const orientation = event.alpha === 90 && event.gamma === -90
            ? DeviceOrientation.Landscape
            : DeviceOrientation.Portrait;
        setOrientation(orientation);
    };
    useEffect(() => {
        window.addEventListener(coreConstants.WindowEvents.Deviceorientation, changeOrientationHandler);
        return () => window.removeEventListener(coreConstants.WindowEvents.Deviceorientation, changeOrientationHandler);
    }, []);
    return deviceOrientation;
}
